import request from "../utils/request";

export function GET_ScheduleWorkItems(token, payload) {
  return request.get("/Schedule/WorkItems", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function GET_ScheduleCalendar(token, payload) {
  return request.get("/Schedule/Calendar", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function GET_ScheduleTimeline(token, payload) {
  return request.get("/Schedule/Timeline", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}
